var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"content"},[_c('login-register-form',{attrs:{"prop-action":_vm.action},on:{"isLogin":_vm.isLogin}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }